// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___ERL1L","root__wrapper":"style-module__root__wrapper___k7IeT","root__wrapper_btn":"style-module__root__wrapper_btn___NibFi","root__wrapper_join":"style-module__root__wrapper_join___rGoJc","root__mainLink":"style-module__root__mainLink___B0ndC","root__navLinks":"style-module__root__navLinks___LrR59","root__navLinks_item":"style-module__root__navLinks_item___dcD7L","root__navLinks_active":"style-module__root__navLinks_active___rjNGp"};
    if(module.hot) {
      // 1697460461701
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  